/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Important_LabelInputs */

const en_embed_captions_important_label = /** @type {(inputs: Embed_Captions_Important_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Important:`)
};

const fr_embed_captions_important_label = /** @type {(inputs: Embed_Captions_Important_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Important :`)
};

const de_embed_captions_important_label = /** @type {(inputs: Embed_Captions_Important_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wichtig:`)
};

const it_embed_captions_important_label = /** @type {(inputs: Embed_Captions_Important_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importante:`)
};

const ru_embed_captions_important_label = /** @type {(inputs: Embed_Captions_Important_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Важный:`)
};

const es_embed_captions_important_label = /** @type {(inputs: Embed_Captions_Important_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importante:`)
};

const zh_cn2_embed_captions_important_label = /** @type {(inputs: Embed_Captions_Important_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重要的：`)
};

const ja_embed_captions_important_label = /** @type {(inputs: Embed_Captions_Important_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重要：`)
};

const hi_embed_captions_important_label = /** @type {(inputs: Embed_Captions_Important_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`महत्वपूर्ण:`)
};

const pt_pt2_embed_captions_important_label = /** @type {(inputs: Embed_Captions_Important_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importante:`)
};

/**
* | output |
* | --- |
* | "Important:" |
*
* @param {Embed_Captions_Important_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_important_label = /** @type {((inputs?: Embed_Captions_Important_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Important_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_important_label(inputs)
	if (locale === "de") return de_embed_captions_important_label(inputs)
	if (locale === "it") return it_embed_captions_important_label(inputs)
	if (locale === "ru") return ru_embed_captions_important_label(inputs)
	if (locale === "es") return es_embed_captions_important_label(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_important_label(inputs)
	if (locale === "ja") return ja_embed_captions_important_label(inputs)
	if (locale === "hi") return hi_embed_captions_important_label(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_important_label(inputs)
	return en_embed_captions_important_label(inputs)
});